import { useQuery } from "@tanstack/react-query";
import type { RecordId } from "../type";
import { getSupplierBlockDetail } from "@/apis/supplier";

export function useBlockRecordDetailQuery(recordId: RecordId) {
  const result = useQuery({
    queryKey: ["blockRecordDetail", recordId],
    queryFn: () => getSupplierBlockDetail(recordId!),
    enabled: !!recordId,
  });

  return result.data?.data.data;
}
